export default __webpack_public_path__ + "static/image-bd00445f2a46745e642b474734790db0.png";